/**
 * Scroll to top of the page
 */
export function scrollToTop(querySelector?: string): void {
  const content = document.querySelector(querySelector || '.content');
  if (content) content.scrollTo({ top: 0, behavior: 'instant' });
}
